import script from "./adminDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./adminDashboard.vue?vue&type=script&setup=true&lang=js"

import "./adminDashboard.vue?vue&type=style&index=0&id=546c2548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546c2548"]])

export default __exports__